<template>
  <div class="sky-thumbnail">
    <div class="img-card">
      <div class="img-card-border"
           v-for="(item,index) in imgArray"
           :key="index"
           @click="onShow"
           :style="{backgroundImage:'url('+item+')',backgroundRepeat:'no-repeat',backgroundSize:'contain',backgroundPosition:'50% 50%'}">
        <a @click.stop="deleteImg(index)"><b>&times;</b></a>
      </div>
      <i class="el-icon-plus"
         @click="onShow"></i>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    value: {
      type: String
    }
  },
  data () {
    return {
      imgArray: []
    }
  },
  methods: {
    onShow () {
      this.$emit('show')
    },
    deleteImg (index) {
      this.imgArray.splice(index, 1)
    }
  },
  watch: {
    value: {
      handler (val) {
        this.imgArray = []
        if (val.length > 0) {
          this.imgArray.push(val)
        }
      }
    },
    immediate: true
  }
}
</script>
<style lang="scss" scoped>
$uploadSize: 80px;
.img-card {
  display: flex;
  flex-wrap: wrap;
  width: 300px;
  min-height: 70px;
  & > i {
    font-size: 30px;
    color: #ccc;
    line-height: $uploadSize;
    text-align: center;
    width: $uploadSize;
    height: $uploadSize;
    border: 1px dashed #c4c6cf;
    border-radius: 4px;
  }
  &-border {
    border: 1px solid #ccc;
    margin-right: 10px;
    width: $uploadSize;
    height: $uploadSize;
    position: relative;
    a {
      position: absolute;
      right: -10px;
      top: -9px;
      width: 18px;
      height: 18px;
      font-size: 16px;
      text-align: center;
      border-radius: 50%;
      background: #ccc;
      color: #fff;
      cursor: pointer;
      display: none;
      align-items: center;
      justify-content: center;
      b {
        font-weight: 100;
      }
    }
    &:hover {
      a {
        display: flex;
      }
    }
  }
}
</style>
